import {Pipe} from "@angular/core";
import { getThumbnailUrl } from "../../utils/media-utils";

@Pipe({
  name: 'thumbnail'
})
export class ThumbnailPipe {
  transform(imageUrl: string | null, video?: boolean): string {
    if (imageUrl) {
      return getThumbnailUrl(imageUrl, video);
    }

    return imageUrl;
  }
}
